export const eventRoutes = [
  {
    path: '/events',
    component: () => import('@/views/events/EventList.vue'),
    name: 'EventList',
    meta: {
      title: 'Danh sách sự kiện',
      auth: true,
    }
  },
  {
    path: '/events/:id',
    component: () => import('@/views/events/EventDetail.vue'),
    name: 'EventDetail',
    meta: {
      title: 'Chi tiết sự kiện',
      auth: true,
    }
  }
]
